<h2 mat-dialog-title class="default-dialog-header font-weight-normal">
	{{ data?.title || 'Exclude carrier' }}
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="p-8" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">
		<div *ngIf="data?.carrierName">
			Excluding <strong>{{ data.carrierName }}</strong> from receiving offers.
		</div>

		<mat-radio-group
			[(ngModel)]="keepInWorkflows"
			fxLayout="column"
			fxLayoutGap="0.5rem"
			aria-label="Exclusion scope"
		>
			<mat-radio-button [value]="false">
				Exclude from all loads and remove from workflows
			</mat-radio-button>
			<mat-radio-button [value]="true">
				Exclude from loads, but keep on their current workflows
			</mat-radio-button>
		</mat-radio-group>

		<mat-form-field style="width: 100%">
			<mat-label>Reason</mat-label>
			<textarea
				[formControl]="reasonControl"
				matInput
				rows="3"
				placeholder="Why is this carrier being excluded?"
				required
			></textarea>
			<mat-error *ngIf="reasonControl?.hasError('required')">A reason is required.</mat-error>
		</mat-form-field>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end center">
		<button (click)="closeDialog()" type="button" mat-button class="m-r-1 primary-text">
			Cancel
		</button>
		<button (click)="confirm()" color="primary" mat-raised-button>Exclude</button>
	</div>
</mat-dialog-actions>
